import {
  CellContext,
  ColumnDef,
  createColumnHelper
} from "@tanstack/react-table";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { IList } from "src/core/lists/api/lists.api";
import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";

export interface IListTableColumns {
  terminology: ITerminology;
  actionButton: (info: CellContext<IList, unknown>) => React.ReactNode;
  pricesVisible: boolean;
}

export const listsTableColumns = (params: IListTableColumns) => {
  const customColumnHelper = customCreateColumnHelper<IList>();
  const columnHelper = createColumnHelper<IList>();

  const columns = [
    customColumnHelper.standardTextColumn(columnHelper, "name", {
      header: "List Name",
      enableColumnFilter: true,
      minSize: 100
    }),
    customColumnHelper.scheduleColumn(columnHelper, params.terminology),
    customColumnHelper.listQuantityColumn(columnHelper),
    customColumnHelper.scheduleStatusColumn(columnHelper, params.terminology),
    customColumnHelper.dateColumn(columnHelper, "createdAt", { header: "Created" }),
    customColumnHelper.dateColumn(columnHelper, "updatedAt", { header: "Last Updated" }),
    customColumnHelper.actionColumn(columnHelper, params.actionButton, { size: 200 })
  ];

  if (params.pricesVisible) {
    columns.splice(2, 0, customColumnHelper.listTotalColumn(columnHelper));
  }

  return columns as Array<ColumnDef<IList, keyof IList>>;
};
